import PauseIcon from '@mui/icons-material/Pause';
import PlayIcon from '@mui/icons-material/PlayArrow';
import LinkIcon from '@mui/icons-material/Link';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import ReactPlayer from 'react-player';
import className from './index.scss';

const styles = {
  button: {
    width: 72,
    height: 72,
    filter: 'drop-shadow(1px 1px 1px #000)',
  },
  container: {
    position: 'relative',
    paddingTop: '56.25%', // 16:9
  },
  link: {
    width: 32,
    height: 32,
    filter: 'drop-shadow(1px 1px 1px #000)',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  overlayButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 72,
    height: 72,
  },
  overlayLink: {
    position: 'absolute',
    top: 16,
    right: 16,
    width: 32,
    height: 32,
  },
  player: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
};

const VideoPlayer = ({
  height = '100%',
  href,
  sources,
  style,
  width = '100%',
}) => {
  const [playing, setPlaying] = useState(true);
  const [mute, setMute] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const onBlur = useCallback(() => {
    if (playing) {
      setShowOverlay(false);
    }
  }, [playing, setShowOverlay]);
  const onFocus = useCallback(() => setShowOverlay(true), [setShowOverlay]);
  const onPause = useCallback(() => setPlaying(false), [setPlaying]);
  const onPlay = useCallback(() => { setMute(false); setPlaying(true); }, [setPlaying]);
  return (
    <div
      onBlur={onBlur}
      onFocus={onFocus}
      onMouseOver={onFocus}
      onMouseLeave={onBlur}
      style={styles.container}
      className={className.videoContainer}
    >
      <ReactPlayer
        playing={playing}
        muted={mute}
        playsinline
        height={height}
        onEnded={useCallback(() => {
          setPlaying(false);
          setShowOverlay(true);
        }, [setPlaying, setShowOverlay])}
        onReady={useCallback(() => setShowOverlay(true), [setShowOverlay])}
        style={useMemo(() => ({ ...styles.player, ...style }), [style])}
        url={sources}
        width={width}
      />
      {useMemo(
        () => showOverlay && (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
              onClick={playing ? onPause : onPlay}
              onKeyPress={playing ? onPause : onPlay}
              style={{
                ...styles.overlay,
                cursor: 'pointer',
              }}
        >
          <div style={styles.overlayButton}>
            {playing ? (
              <PauseIcon color='#FFF' style={styles.button} />
                ) : (
                  <PlayIcon color='#FFF' style={styles.button} />
                )}
          </div>
          {href && (
          <a
                  href={href}
                  aria-label='link'
                  onClick={e => e.stopPropagation()}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={styles.overlayLink}
          >
            <LinkIcon color='#FFF' style={styles.link} />
          </a>
              )}
        </div>
          ),
        [href, onPause, onPlay, playing, showOverlay],
      )}
    </div>
  );
};

VideoPlayer.propTypes = {
  controls: PropTypes.bool,
  height: PropTypes.string,
  href: PropTypes.string,
  sources: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
      }),
    ),
  ]).isRequired,
  style: PropTypes.object,
  width: PropTypes.string,
};

export default VideoPlayer;
